var _title, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconFilterNew = function SvgIconFilterNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "22px",
    viewBox: "0 0 31 22",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icon / Filter")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.56486429,19.3660737 C9.15497725,19.8246684 9.57640124,20.4733515 9.76093368,21.2071414 L29.104772,21.2071414 C29.2019088,21.1839735 29.302961,21.1839735 29.4000978,21.2071414 C29.495642,21.2499184 29.5850572,21.3057617 29.665891,21.3731393 C29.7417643,21.4480871 29.7976707,21.5415803 29.8283201,21.6447722 C29.8750274,21.7485962 29.8953429,21.8627867 29.8873853,21.976768 C29.9095382,22.0760992 29.9095382,22.1792513 29.8873853,22.2785824 C29.8567359,22.3817743 29.8008295,22.4752675 29.7249561,22.5502153 C29.6478982,22.6228674 29.5575774,22.6792762 29.4591629,22.7162133 C29.3613105,22.7317836 29.2616896,22.7317836 29.1638371,22.7162133 L9.76093368,22.7162133 C9.36318854,24.2065182 8.03865181,25.2403964 6.52711644,25.2403964 C5.01558107,25.2403964 3.69104433,24.2065182 3.29329919,22.7162133 L0.694432367,22.7162133 C0.375030331,22.7258064 0.0832009206,22.5322427 -0.0382986702,22.2302099 C-0.159798261,21.9281771 -0.0855681796,21.5808159 0.148079681,21.3580486 C0.292529952,21.2098523 0.489782134,21.1281283 0.694432367,21.1316878 L3.29329919,21.1316878 C3.59353272,20.035447 4.40916596,19.1645684 5.46766749,18.8100427 C6.52616902,18.455517 7.68796697,18.6640913 8.56486429,19.3660737 Z M6.53533519,4.84039643 C8.04716045,4.84039643 9.37195121,5.8734886 9.76977263,7.3626604 L29.1173207,7.3626604 C29.214535,7.34003795 29.3154889,7.34003795 29.4127032,7.3626604 C29.5082657,7.40540492 29.5976981,7.46120568 29.6785473,7.52853209 C29.7544352,7.60342292 29.8103524,7.69684507 29.8410077,7.7999585 C29.8928743,7.91276527 29.9133136,8.03797643 29.9000841,8.16186037 C29.9084971,8.37633943 29.8287325,8.58464812 29.6800729,8.7364293 C29.5314133,8.88821047 29.3273888,8.96964996 29.1173207,8.96106034 L9.76977263,8.96106034 C9.47099645,10.0382122 8.67312034,10.8968417 7.63528157,11.2580797 C6.59744281,11.6193177 5.45202529,11.4370857 4.57104214,10.7705697 C3.95871428,10.332136 3.51077192,9.69397557 3.30089776,8.96106034 L0.701532518,8.96106034 C0.49323447,8.96051095 0.292809673,8.87973463 0.140305931,8.73487167 C-0.00573427489,8.58066547 -0.0900220627,8.37627849 -0.096,8.16186037 C-0.0956164432,7.95064195 -0.0101632611,7.74888202 0.140305931,7.60392832 C0.283275468,7.45175837 0.480247149,7.36479287 0.686763397,7.3626604 L3.30089776,7.3626604 C3.69871918,5.8734886 5.02350994,4.84039643 6.53533519,4.84039643 Z",
    id: "Filterpath-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8881789,15.3870162 C29.9092737,15.4909588 29.9092737,15.5981807 29.8881789,15.7021234 C29.8537991,15.7985872 29.798234,15.8858243 29.7257032,15.9572102 C29.6523457,16.0343106 29.5608362,16.0911212 29.4598339,16.1222663 C29.3626104,16.1447775 29.261647,16.1447775 29.1644236,16.1222663 L26.3727959,16.1222663 C26.0896295,17.2169621 25.285327,18.0946752 24.2307373,18.4598358 C23.1761476,18.8249964 22.0116025,18.6290134 21.1292625,17.937884 C20.5420335,17.4882916 20.1248312,16.8472512 19.9476212,16.1222663 L0.745949579,16.1222663 C0.525727232,16.1542332 0.302112899,16.0947374 0.125587881,15.9572102 C-0.0175881201,15.8030923 -0.0969189117,15.5989291 -0.096,15.3870162 C-0.0977791572,15.1793764 -0.0180423618,14.9795686 0.125587881,14.8318273 C0.27007951,14.6844718 0.467388169,14.6032114 0.672096996,14.6067507 L19.8737686,14.6067507 C20.251192,13.0776817 21.6160494,12.0144648 23.1675938,12.0408777 C24.6953236,12.0383812 26.0260962,13.098823 26.3875664,14.6067507 L29.120112,14.6067507 C29.3250334,14.6026272 29.5227615,14.6835087 29.6676912,14.8307402 C29.812621,14.9779717 29.8922379,15.1788402 29.8881789,15.3870162 L29.8881789,15.3870162 Z",
    id: "Filterpath-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02.2---Ventas---Ventas-del-grupo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1254.000000, -148.000000)",
    id: "Info"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(278.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Filter",
    transform: "translate(977.000000, 124.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Filtermask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Filterpath-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#744CC6",
    fillRule: "nonzero",
    xlinkHref: "#Filterpath-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "FilterIcon",
    mask: "url(#Filtermask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline-color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Filtermask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Filterpath-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "FilterIcon",
    mask: "url(#Filtermask-4)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline-color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFilterNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_filter_new.33704e7f.svg";
export { ForwardRef as ReactComponent };